import { STATUS_STYLES, PRIORITY_STYLES, TYPE_STYLES, TALMIA_STYLES, TALMIA_META } from "../constants/enums";

function Pill({ styles, label, testId }) {
  return (
    <span className={`pill ${styles.bg} ${styles.text} ${styles.border}`} data-testid={testId}>
      {label}
    </span>
  );
}

export function StatusBadge({ value }) {
  const s = STATUS_STYLES[value] || STATUS_STYLES["New"];
  return <Pill styles={s} label={value} testId={`status-badge-${value}`} />;
}

export function PriorityBadge({ value }) {
  const s = PRIORITY_STYLES[value] || PRIORITY_STYLES["Medium"];
  return <Pill styles={s} label={value} testId={`priority-badge-${value}`} />;
}

export function TypeBadge({ value }) {
  const s = TYPE_STYLES[value] || TYPE_STYLES["Bug"];
  return <Pill styles={s} label={value} testId={`type-badge-${value}`} />;
}

export function TalmiaBadge({ value }) {
  const v = value || "1";
  const s = TALMIA_STYLES[v] || TALMIA_STYLES["1"];
  const label = TALMIA_META[v]?.label || v;
  return <Pill styles={s} label={label} testId={`talmia-badge-${v}`} />;
}
